"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pouchdb_1 = __importDefault(require("pouchdb"));
const constants_1 = require("../../utils/constants");
class LocalPouchStats {
    constructor(remoteDbUrl) {
        this.store = new pouchdb_1.default(constants_1.Collections.STATS, { auto_compaction: true });
        this.store.createIndex({
            index: {
                fields: ['ownerId', 'type', 'createdAt'],
                ddoc: 'by-ownerId-type-createdAt',
            },
        });
        if (remoteDbUrl) {
            const remote = new pouchdb_1.default(remoteDbUrl);
            this.store.sync(remote, { live: true, retry: true });
        }
    }
    setDoc(stats) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const doc = yield this.store.get(stats.id);
                yield this.store.put(Object.assign(Object.assign({}, stats), { _id: stats.id, _rev: doc._rev }));
            }
            catch (err) {
                yield this.store.put(Object.assign(Object.assign({}, stats), { _id: stats.id }));
            }
        });
    }
    getDoc(id, type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.store.get(id);
                return result;
            }
            catch (err) {
                return {
                    id: id,
                    type: type,
                    createdAt: new Date().toISOString(),
                    value: 0,
                };
            }
        });
    }
    getDailyStats(ownerId, statName) {
        return __awaiter(this, void 0, void 0, function* () {
            const d = new Date();
            const id = `${statName}-${ownerId}-${d.getDay()}-${d.getMonth()}-${d.getFullYear()}`;
            return yield this.getDoc(id, 'daily');
        });
    }
    getAllTimeStats(ownerId, statName) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = `${statName}-${ownerId}`;
            return yield this.getDoc(id, 'all-time');
        });
    }
}
exports.default = LocalPouchStats;
